import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'

@NgModule({
  providers: [
    provideConfig({
      cmsComponents: {
        vicSchoolsComponent: {
          component: () => import('./vic-school.component').then((c) => c.VicSchoolComponent)
        }
      }
    })
  ]
})
export class VicSchoolModule {}
